// extracted by mini-css-extract-plugin
export default {"Tag":"Tag-module__Tag___2JQTF"};